import { Link } from "gatsby"
import React from "react"


import logoStyle from './scatter_image.module.scss'

const ScatterImage = ({ x, y, logoUrl, team, season, includeSeason }) => {

    const ShowYear = ({includeSeason}) => {
        if (includeSeason) {

            return (
                <Link className={logoStyle.teamPageLinkP} to={`/teams/${team.toLowerCase()}/${season}/`}>
                    <p className={logoStyle.yearP}>
                        {season}
                    </p>
                </Link>
            ) 

        } else {

            return (
                null
            )

        }
    }

    return (
        <foreignObject className={logoStyle.foreignObject} x={x-14} y={y-14} height={'40px'}>
            <div className={logoStyle.logoDiv}>
                <Link className={logoStyle.teamPageLink} to={`/teams/${team.toLowerCase()}/${season}/`}>
                    <img
                        className={logoStyle.teamLogo}
                        src={logoUrl}
                        alt={team}>
                    </img>
                </Link>
                <ShowYear
                    includeSeason={includeSeason}
                />
            </div>
        </foreignObject>
    )

}

export default ScatterImage